define(function () {

    'use strict';

    return {

    };

});


//////////////////
// WEBPACK FOOTER
// ./src/config/metadata-editor.js
// module id = 67
// module chunks = 0